import React, { useState } from "react";
import { t } from "i18next";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react/dist/chakra-ui-react.cjs";
import EDatePicker from "components/EDatePicker";
import PrimaryButton from "components/Buttons/PrimaryButton";
import GreenButton from "components/Buttons/GreenButton";
import { useDocumentStore } from "store/documentStore";

const DocumentFilter = ({
  onSearch,
  searchName,
  setSearchName,
  fiscalYearJp,
  setFiscalYearJp,
  formMethods = null,
  isBulkAssign = false,
  documentParams = {},
  setDocumentParams = null,
}) => {
  const { setListDocument } = useDocumentStore();
  const selectedDocuments = formMethods?.getValues?.("selectedDocuments") ?? [];

  const enterSearch = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  const onChangeYearMonthPicker = (date) => {
    // Handle date picker selection (date is a Date object)
    if (date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      setFiscalYearJp(`${year}-${String(month).padStart(2, "0")}`);
    } else {
      // Handle clearing the date
      setFiscalYearJp("");
    }
  };

  const onKeyDownYearMonthPicker = (e) => {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', '-'];
    const isNumber = e.key >= '0' && e.key <= '9';
    
    if (!isNumber && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onInputYearMonthPicker = (e) => {
    const value = e.target.value;
    // Allow yyyy-mm format: numbers and one hyphen
    const cleanedValue = value.replace(/[^0-9-]/g, '');
    // Ensure only one hyphen
    const parts = cleanedValue.split('-');
    let formattedValue = parts[0] || '';
    if (parts.length > 1) {
      formattedValue += '-' + parts.slice(1).join('').replace(/-/g, '');
    }
    
    if (value !== formattedValue) {
      e.target.value = formattedValue;
    }
    
    // Validate and set the value
    if (formattedValue.length === 0) {
      setFiscalYearJp("");
      return;
    }
    
    const match = formattedValue.match(/^(\d{4})-(\d{1,2})$/);
    if (match) {
      const year = parseInt(match[1]);
      const month = parseInt(match[2]);
      if (year >= 1900 && year <= 3000 && month >= 1 && month <= 12) {
        setFiscalYearJp(`${year}-${String(month).padStart(2, "0")}`);
      }
    }
  };
  
  const onFilterOnlySelected = () => {
    if (!isBulkAssign) return;
   
    setListDocument(selectedDocuments);

    // return to page 1
    if (setDocumentParams) {
      setDocumentParams({...documentParams, page: 1});
    }
  };

  return (
    <FormControl>
      <Flex mt="20px" align="center" gap="20px">
        <Flex align="center">
          <FormLabel
            w="150px"
            mt={{ base: "7px" }}
            fontSize="14px"
            textAlign={"left"}
            mr={"30px"}
            fontWeight={"bold"}
          >
            {t("pages.document.list.search_form.search_label")}
          </FormLabel>
          <Input
            w="200px"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            onKeyDown={enterSearch}
            fontSize="14px"
          />
        </Flex>
        <Flex align="center">
          <FormLabel
            w="100px"
            mt={{ base: "7px" }}
            fontSize="14px"
            textAlign={"end"}
            mr={"20px"}
            fontWeight={"bold"}
          >
            {t("pages.document.list.search_form.fiscal_year")}
          </FormLabel>
          <Box>
            <EDatePicker
              selected={
                fiscalYearJp ? new Date(fiscalYearJp + "-01") : null
              }
              onChange={onChangeYearMonthPicker}
              onKeyDown={onKeyDownYearMonthPicker}
              onInput={onInputYearMonthPicker}
              showMonthYearPicker
              dateFormat="yyyy-MM"
              maxLength={7}
              placeholder="yyyy-mm"
            />
          </Box>
        </Flex>
        <PrimaryButton
          text={t("pages.document.list.search_form.search_button")}
          onClick={onSearch}
          w="80px"
          size={"sm"}
        />
        {isBulkAssign && (
          <GreenButton
            disabled={!selectedDocuments.length}
            onClick={onFilterOnlySelected}
            text={t("pages.bulk_assign.filter_only_selected")}
          />
        )}
      </Flex>
    </FormControl>
  );
};

export default DocumentFilter;
